@if(data) {
  <div>
    <h2 class="text-lg font-semibold text-gray-900 mb-2">Primary Objectives</h2>
    <ul class="list-disc list-inside mb-4">
      @for(obj of primaryObjectives; track obj) {
      <li class="text-gray-800 mb-1">{{ obj }}</li>
      }
    </ul>

    <h2 class="text-lg font-semibold text-gray-900 mb-2">Secondary Objectives</h2>
    <ul class="list-disc list-inside">
      @for(obj of secondaryObjectives; track obj) {
      <li class="text-gray-800 mb-1">{{ obj }}</li>
      }
    </ul>
  </div>
}
